import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const PageHero = ({ eyebrow, title, lede, image }) => (
  <section data-testid="page-hero" className="relative flex min-h-[70vh] items-end overflow-hidden border-b border-white/10 pt-24">
    <div className="absolute inset-0">
      <img src={image} alt={title} className="h-full w-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/30" />
      <div className="blueprint-grid absolute inset-0 opacity-30" />
    </div>
    <div className="relative mx-auto w-full max-w-[1440px] px-6 pb-16 md:px-12 md:pb-24">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
        <div className="mb-5 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">{eyebrow}</span>
        </div>
        <h1 className="max-w-4xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">{title}</h1>
        <p className="mt-6 max-w-2xl font-body text-base leading-relaxed text-slatex-300 md:text-lg">{lede}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/contact" data-testid="pagehero-request" className="border border-brand-cyan/40 bg-brand-cyan/10 px-6 py-3 font-mono text-xs uppercase tracking-widest text-brand-cyan transition-colors hover:bg-brand-cyan hover:text-ink">Request Service</Link>
          <a href="tel:7739317012" className="border border-white/15 px-6 py-3 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:border-white/40">Call 773-931-7012</a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default PageHero;
